import { Instance, types } from "mobx-state-tree";

export enum EntityTypeFromPath {
  Job = 'jobs',
  Project = 'projects',
  SewerObject = 'sewer-objects',
  Inspection = 'inspections',
  Damage = 'damages'
}

export const EntityTypeFromPathModel = types.model({
  entity: types.frozen<EntityTypeFromPath>(),
  name: types.string,
});

export type EntityName = Instance<typeof EntityTypeFromPathModel>;
